const items = [];
let isAnimating = false;

async function run () {
    if (isAnimating || items.length === 0) {
        return;
    }

    if (items.length) {
        const currentItem = items.shift();
        isAnimating = true;
        await currentItem.run(currentItem.param);
        isAnimating = false;
        run();
    }
};

function addItem (item) {
    items.push(item);

    if (!isAnimating) {
        run();
    }
};


const DoodleAnimationQueue = {
    addItem,
    run
};

export { DoodleAnimationQueue };